import { ObservationResponseAllDto } from "../../../../../common/dtos/observation/observation.response.all";
import { Component, Input, OnChanges } from "@angular/core";
import { Chart, registerables } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(...registerables, ChartDataLabels);

@Component({
  selector: "app-line-chart",
  templateUrl: "./line-chart.component.html",
  styleUrls: [
    "./line-chart.component.scss"
  ]
})
export class LineChartComponent implements OnChanges {

  public chartLine: Chart | null = null;
    @Input() data: ObservationResponseAllDto | undefined;

    // constructor() {}

    ngOnChanges(): void {
      if (this.data) {
        this.createChart(this.data);
      }
    }

    createChart(result: ObservationResponseAllDto) {
      const dateCounts: { [key: string]: number } = {};
      result.content.forEach((item) => {
        const dateObj = new Date(item.insert_date);
        const date = dateObj.toISOString().split("T")[0];
        if (dateCounts[date]) {
          dateCounts[date]++;
        } else {
          dateCounts[date] = 1;
        }
      });
      const labels = Object.keys(dateCounts).sort();
      const values = labels.map((date) => dateCounts[date]);

      if (this.chartLine) {
        this.chartLine.destroy();
      }

      this.chartLine = new Chart("LineChart", {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              label: "Observation Card",
              data: values,
              borderColor: "blue",
              backgroundColor: "white",
              fill: false,
              tension: 0.5,
              datalabels: {
                align: "start",
                anchor: "start"
              }
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            datalabels: {
              borderRadius: 4,
              display: true, // Mostra le etichette
              color: "black", // Colore del testo
              align: "top", // Posizione delle etichette (sopra la linea)
              font: {
                weight: "bold"
              },
              formatter: (value: number) => {
                return value.toString(); // Mostra il valore come etichetta
              },
              padding: 6
            }
          },
          aspectRatio: 5 / 3,
          layout: {
            padding: {
              top: 32,
              right: 16,
              bottom: 16,
              left: 8
            }
          },
          elements: {
            line: {
              fill: false,
              tension: 0.4
            }
          },
          scales: {
            y: {
              stacked: true,
              beginAtZero: true
            }
          }
        }
      });
    }
}
